export default __webpack_public_path__ + "static/media/330_dummy2016-irishpub01-de.5b7f7c57.png";